import React from 'react';

function randomId() {
  return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
}

export class Focuspoint extends React.Component {

  constructor(props) {
    super(props);
    this.id = randomId();
  }

  componentDidMount() {
    window.$('#'+this.id).focusPoint({
      reCalcOnWindowResize: true
    });
  }

  componentDidUpdate() {
    window.$('#'+this.id).focusPoint('adjustFocus');
  }

  componentWillUnmount() {
    window.$('#'+this.id).focusPoint('windowOff');
  }

  getImgSrc() {
    var hParam = '&h=';
    if(this.props.src && !this.props.src.includes('?')) {
      hParam = '?h=';
    }
    return this.props.src + hParam + this.props.imageH;
  }

  render() {
    return (<div className="focuspoint" id={this.id}
      data-focus-x={this.props.focusX}
      data-focus-y={this.props.focusY}
      data-image-w={this.props.imageW}
      data-image-h={this.props.imageH}>
        <img src={this.getImgSrc()} alt="" />
    </div>)
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/Focuspoint.js